export abstract class LoadingService {
	abstract open(): void;

	abstract close(): void;
}
